/* ログ一覧検索コントロール */
import React from 'react';
import DateTimePicker from './DateTimePicker';
import { inputAssistDigit } from '../Convert';
var LogSearchForm = function (_a) {
    var _b, _c;
    var options = _a.options, search_params = _a.search_params, handleClickSearch = _a.handleClickSearch, handleChangeSearchParams = _a.handleChangeSearchParams, is_connecting = _a.is_connecting, message = _a.message, help_msg = _a.help_msg;
    /**
     * 時間From
     * @param Date value フォームで入力された文字列
     */
    var handleChangeCreatedAt = function (value) {
        if (isEmpty(search_params.created_at_to_ymd)) {
            handleChangeSearchParams(['created_at_from_ymd', 'created_at_to_ymd'], value);
        }
        else {
            handleChangeSearchParams('created_at_from_ymd', value);
        }
    };
    /**
     * empty判定
     * @param string value 入力値
     */
    var isEmpty = function (value) {
        return value === null || typeof value === 'undefined' || value.length === 0;
    };
    /**
     * バリデーションメッセージを取得する
     * @param keys 取得キー
     * @returns バリデーションメッセージ
     */
    var getMessage = function (keys) {
        // バリデーションメッセージ取得
        var msg_list = [];
        keys.map(function (key) {
            message === null || message === void 0 ? void 0 : message.map(function (msg) {
                if (msg.key === key) {
                    msg_list.push(msg.message);
                }
            });
        });
        // 重複を除去した配列を返す
        var msg_list_dupl = msg_list.filter(function (x, i, self) {
            return self.indexOf(x) === i;
        });
        // 配列内のメッセージを結合した値を返却
        return msg_list_dupl.join('\n');
    };
    return (React.createElement("div", { id: "search" },
        React.createElement("div", { className: "search-area" },
            React.createElement("div", { className: "search-container" },
                React.createElement("div", { className: "row my-2" },
                    React.createElement("div", { className: "col-md-8 col-sm-16" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u6642\u9593"),
                        React.createElement(DateTimePicker, { id: "created-at-from", handleChangeDate: function (date) { return handleChangeCreatedAt(date); }, selected_ymd: search_params.created_at_from_ymd.length > 0
                                ? new Date(search_params.created_at_from_ymd)
                                : null, selected_hour: search_params.created_at_from_hour.length > 0
                                ? search_params.created_at_from_hour
                                : '', selected_minute: search_params.created_at_from_minute.length > 0
                                ? search_params.created_at_from_minute
                                : '', message: getMessage([
                                'created_at_from_ymd',
                                'created_at_from_hour',
                                'created_at_from_minute',
                            ]), help_msg: '', customInput: React.createElement("input", { type: "text", className: "search-form-input" }), handleChangeHour: function (hour) {
                                return handleChangeSearchParams('created_at_from_hour', hour);
                            }, handleChangeMinute: function (minute) {
                                return handleChangeSearchParams('created_at_from_minute', minute);
                            } }),
                        React.createElement("span", { className: "search-criteria-head-small" }, "\uFF5E"),
                        React.createElement(DateTimePicker, { id: "created-at-to", handleChangeDate: function (date) {
                                return handleChangeSearchParams('created_at_to_ymd', date);
                            }, selected_ymd: search_params.created_at_to_ymd.length > 0
                                ? new Date(search_params.created_at_to_ymd)
                                : null, selected_hour: search_params.created_at_to_hour.length > 0
                                ? search_params.created_at_to_hour
                                : '', selected_minute: search_params.created_at_to_minute.length > 0
                                ? search_params.created_at_to_minute
                                : '', message: getMessage([
                                'created_at_to_ymd',
                                'created_at_to_hour',
                                'created_at_to_minute',
                            ]), help_msg: '', customInput: React.createElement("input", { type: "text", className: "search-form-input" }), handleChangeHour: function (hour) {
                                return handleChangeSearchParams('created_at_to_hour', hour);
                            }, handleChangeMinute: function (minute) {
                                return handleChangeSearchParams('created_at_to_minute', minute);
                            } })),
                    React.createElement("div", { className: "col-md-3 col-sm-6" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u6848\u4EF6\u756A\u53F7"),
                        React.createElement("input", { type: "text", className: "search-form-input", name: "", value: search_params.reception_cd, onChange: function (event) {
                                return handleChangeSearchParams('reception_cd', event === null || event === void 0 ? void 0 : event.target.value);
                            }, onBlur: function (event) {
                                return handleChangeSearchParams('reception_cd', inputAssistDigit(event === null || event === void 0 ? void 0 : event.target.value));
                            } }))),
                React.createElement("div", { className: "row my-2" },
                    React.createElement("div", { className: "col-md-8 col-sm-16" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u30ED\u30B0\u30EC\u30D9\u30EB"),
                        React.createElement("select", { name: "\u30ED\u30B0\u30EC\u30D9\u30EB", className: "search-form-input", value: search_params.error_level, onChange: function (event) {
                                return handleChangeSearchParams('error_level', event === null || event === void 0 ? void 0 : event.target.value);
                            } },
                            React.createElement("option", null), (_b = options === null || options === void 0 ? void 0 : options.error_level) === null || _b === void 0 ? void 0 :
                            _b.map(function (option, index) {
                                return (React.createElement("option", { key: index, value: option.key }, option.value));
                            }))),
                    React.createElement("div", { className: "col-md-3 col-sm-6" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u6848\u4EF6\u679D\u756A\u53F7"),
                        React.createElement("select", { name: "\u6848\u4EF6\u679D\u756A\u53F7", className: "search-form-input", value: search_params.reception_sub_cd, onChange: function (event) {
                                return handleChangeSearchParams('reception_sub_cd', event === null || event === void 0 ? void 0 : event.target.value);
                            } },
                            React.createElement("option", null), (_c = options === null || options === void 0 ? void 0 : options.reception_sub_cd) === null || _c === void 0 ? void 0 :
                            _c.map(function (option, index) {
                                return (React.createElement("option", { key: index, value: option.key }, option.value));
                            })))),
                React.createElement("div", { className: "row my-2" },
                    React.createElement("div", { className: "col-md-8 col-sm-16" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u64CD\u4F5C"),
                        React.createElement("input", { type: "text", className: "search-form-input", name: "\u64CD\u4F5C", value: search_params.operation, onChange: function (event) {
                                return handleChangeSearchParams('operation', event === null || event === void 0 ? void 0 : event.target.value);
                            } })),
                    React.createElement("div", { className: "col-md-3 col-sm-6" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u63A5\u7D9A\u60C5\u5831"),
                        React.createElement("input", { type: "text", className: "search-form-input", name: "\u63A5\u7D9A\u60C5\u5831", value: search_params.src_address, onChange: function (event) {
                                return handleChangeSearchParams('src_address', event === null || event === void 0 ? void 0 : event.target.value);
                            } }))),
                React.createElement("div", { className: "row my-2" },
                    React.createElement("div", { className: "col-md-8 col-sm-16" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u30E1\u30C3\u30BB\u30FC\u30B8ID"),
                        React.createElement("input", { type: "text", className: "search-form-input", name: "\u30E1\u30C3\u30BB\u30FC\u30B8ID", value: search_params.message_code, onChange: function (event) {
                                return handleChangeSearchParams('message_code', event === null || event === void 0 ? void 0 : event.target.value);
                            } }))),
                React.createElement("div", { className: "row my-2" },
                    React.createElement("div", { className: "col-md-10 col-sm-20" },
                        React.createElement("span", { className: "search-criteria-head" }, "\u30E1\u30C3\u30BB\u30FC\u30B8"),
                        React.createElement("input", { type: "text", className: "search-form-input-large", name: "\u30E1\u30C3\u30BB\u30FC\u30B8", value: search_params.message, onChange: function (event) {
                                return handleChangeSearchParams('message', event === null || event === void 0 ? void 0 : event.target.value);
                            } })),
                    React.createElement("div", { className: "col-md-2 col-sm-4" },
                        React.createElement("div", { className: "search-btn" },
                            React.createElement("button", { className: "btn btn-main-color", disabled: false, onClick: function () { return handleClickSearch(); } }, "\u691C\u3000\u7D22"))))))));
};
export default LogSearchForm;
